<template>
  <div>
    <div class="container">
        <el-form>
            <el-row gutter="8">
                <el-col span="4">
                    <el-form-item>
                        <el-input placeholder="输入手机号搜索" prefix-icon="el-icon-search" size="small" v-model="params.mobile"></el-input>
                    </el-form-item>
                </el-col>
                <el-col span="4">
                    <el-form-item>
                        <el-select v-model="params.isagent" placeholder="请选择" size="small">
                            <el-option label="全部" :value="0"> </el-option>
                            <el-option label="非分销员" :value="1"> </el-option>
                            <el-option label="是分销员" :value="2"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col span="4">
                    <el-form-item>
                        <el-button @click="onSearch" size="small">搜索</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
    <div class="container">
      <el-table :data="list" border style="width: 100%">
        <el-table-column align="center" label="ID" prop="id" width="50" />
        <el-table-column label="用户">
          <template slot-scope="{ row }">
            <div class="member">
              <div class="member-avatar">
                <img :src="row.avatar" class="member-avatar" alt="" />
              </div>
              <div>
                <div>{{ row.nickname }}</div>
                <div v-if="row.isvip === 2" class="member-tag">会员</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" prop="mobile" />
        <el-table-column label="性别">
          <template slot-scope="{ row }">
            <div>{{ { 0: '未知', 1: '男', 2: '女' }[row.gender] }}</div>
          </template>
        </el-table-column>
        <el-table-column label="地区">
          <template slot-scope="{ row }">
            <div>{{ row.province }}/{{ row.city }}</div>
          </template>
        </el-table-column>
        <el-table-column label="余额">
          <template slot-scope="{ row }">
            <div v-if="row.balance == 0">{{ row.balance / 100 }}元</div>
            <div v-if="row.balance > 0" style="color:#ff4f4f">{{ row.balance / 100 }}元</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="{ row }">
            <el-button @click="onClickSearchByUser(row)" size="small" type="text">最近订单</el-button>
            <el-button @click="updateisagent(row, 2)" size="small" type="text" v-if="row.isagent == 1">设为分销员</el-button>
            <el-button @click="updateisagent(row, 1)" size="small" type="text" v-if="row.isagent == 2">取消分销员</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-bottom">
        <el-button v-if="hasMore" :loading="loadmore" @click="getUsers" size="small" type="primary">加载更多</el-button>
        <span v-else style="color: #ccc; font-size: 12px;">已经加载全部，没有更多了</span>
      </div>
    </div>

    <!-- 添加分类弹框 -->
    <el-dialog :visible.sync="showDialog" title="订单列表" width="800px">
      <div class="item" :key="data.id" v-for="data in orderlist">
        <div class="order-detail">
          <div>
            <span class="order-detail_text">{{ data.id }}</span>
            <span class="invoice m10" v-if="data.groupuuid">拼团</span>
            <span class="invoice m10" v-if="data.needinvoice">需要开发票</span>
          </div>
          <div>
            <span class="order-detail_text m10">{{ data.user.nickname }} {{ data.user.mobile }}</span>
            <span class="member-tag" style="padding: 0 4px;" v-if="data.user.isvip === 2">会员</span>
            <span class="order-detail_text m10">{{ new Date(data.createdat * 1000).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) }}</span>
            <el-button @click="$router.push({ name: 'order-detail', query: { id: data.id } })" size="small" type="text">查看详情</el-button>
          </div>
        </div>
        <div class="table">
          <div class="products">
            <div class="product" :key="oproduct.id" v-for="oproduct in data.orderproductsList">
              <div class="product-info">
                <div class="product-img">
                  <comp-imger :src="oproduct.product.imagesList.length ? oproduct.product.imagesList[0] : ''" />
                </div>
                <div>
                  <div class="product-name">{{ oproduct.product.name }}</div>
                </div>
              </div>
              <div class="price">{{ $amount1(oproduct.amount) }} 元</div>
              <div class="count">{{ oproduct.quantity }} 个</div>
              <div class="count" v-if="data.status == 2">
                <span class="action-text" v-if="oproduct.confirmed == 1">未核销</span>
                <span class="action-text" v-if="oproduct.confirmed == 2">已核销</span>
              </div>
              <div class="count" v-if="data.status != 2">
                <span class="action-text">/</span>
              </div>
            </div>
          </div>
          <div class="action">
            <span class="action-text">{{ map[data.status] || '非此类型商城该有状态' }}</span>
          </div>
        </div>
      </div>
      <div v-if="!orderlist.length">该用户还未创建过订单</div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../../components/tab/index.vue';
import { M } from '../../../service/grpc.js';
import { rpc, rpc1 } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

const map = {
  '0': '等待买家支付',
  '1': '拼团中',
  '2': '待核销',
  '4': '已核销',
  '5': '团购失败',
  '6': '买家已取消订单',
  '8': '已退款',
  '12': '买家申请退款'
};
export default {
  data() {
    return {
      map,
      showDialog: false,
      list: [],
      orderlist: [],
      params: {
        mobile: '',
        isagent: 0,
        count: 20,
        idlessthan: 0
      },
      loadmore: false,
      hasMore: true,
      token: ''
    };
  },
  created() {
    this.token = getToken();
    this.getUsers();
  },
  methods: {
    async updateisagent(row, isagent) {
      console.log(row, isagent);
      const res = await rpc(
        'StoreUserService.UpdateUserIsAgent',
        M('UpdateUserIsAgentI', {
          token: M('Token', { token: this.token }),
            id: row.id,
            isagent,
        })
      );
      this.list.splice(this.list.findIndex(v => v.id === res.id), 1, res);
    },
    async onClickSearchByUser(row) {
      this.orderlist = [];
      const res = await rpc1(
        'StoreOrderService.GetOrderList',
        M('OrderListQueryRequest', {
          token: M('Token', { token: this.token }),
          userid: row.id,
          status: -1,
          count: 5,
          sortby: 1,
          sort: 1
        })
      );
      if (res.orderlistList.length === 0) {
        this.showDialog = true;
        return;
      }
      const productidlist = [];
      res.orderlistList.forEach(item => {
        item.orderproductsList.forEach(item1 => {
          productidlist.push(item1.productid);
        });
      });
      const res1 = await rpc1(
        'StoreProductService.GetProductList',
        M('ProductListQueryRequest', {
          token: M('Token', { token: this.token }),
          idlistList: productidlist,
          sortby: 1,
          sort: 1,
          count: productidlist.length
        })
      );
      res.orderlistList.forEach(item => {
        item.user = row;
        item.orderproductsList.forEach(item1 => {
          item1.product = res1.productlistList.find(v => v.id === item1.productid);
        });
      });
      this.orderlist = res.orderlistList;
      this.showDialog = true;
    },

    onSearch() {
      this.list = [];
      this.getUsers();
    },

    async getUsers() {
      this.loadmore = true;
      const { scrollY } = window;
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;
      const res = await rpc(
        'StoreUserService.GetUserList',
        M('UserListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      this.list = this.list.concat(res.userlistList);
      this.hasMore = res.userlistList.length;
      if (this.params.idlessthan !== 0) {
        window.scroll(0, scrollY);
      }
      this.loadmore = false;
    }
  }
};
</script>

<style>
.member {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.member-avatar {
  width: 40px;
  height: 40px;
  margin-right: 8px;
}

.member-tag {
  font-size: 10px;
  color: #ff4f4f;
  background-color: #f0dcdc;
  width: 36px;
  text-align: center;
  line-height: 18px;
  border-radius: 3px;
}
.input-width {
  width: 170px;
}
.list-nodata {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  color: #999;
}
.list-tabs {
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 15px;
}
.el-select {
  width: 100%;
}
.item {
  margin-bottom: 10px;
}
.item:last-child {
  margin-bottom: none;
}
.order-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8f8;
  padding: 5px 10px;
}

.table {
  box-sizing: border-box;
  border: 1px solid #e9e9e9;
  display: flex;
  justify-content: space-between;
}
.products {
  flex: 1;
  border-right: 1px solid #e9e9e9;
}
.action {
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.action-text {
  font-size: 14px;
  color: #666;
  padding-bottom: 10px;
}
.invoice {
  background-color: #e9e9e9;
  color: #4ba3dd;
  font-size: 12px;
  padding: 3px;
  border-radius: 3px;
}
.order-detail_text {
  color: #666;
  font-size: 14px;
}
.m10 {
  margin: 0 10px;
}
.member-tag {
  font-size: 10px;
  color: #ff4f4f;
  background-color: #f0dcdc;
  width: 36px;
  text-align: center;
  line-height: 18px;
  border-radius: 3px;
}
.product {
  display: flex;
  border-bottom: 1px solid #e9e9e9;
}
.product:last-child {
  border-bottom: none;
}
.product-info {
  padding: 10px;
  display: flex;
  flex: 1;
}
.product-img {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  & > img {
    width: 80px;
    height: 80px;
  }
}
.product-name {
  margin-top: 10px;
  font-weight: bold;
  font-size: 14px;
  color: #333;
}
.product-desc {
  margin-top: 10px;
  font-size: 12px;
  color: #666;
}
.price,
.count {
  display: flex;
  width: 100px;
  align-items: center;
  justify-content: center;
  border-left: 1px solid #e9e9e9;
}
</style>
